import { jsx } from 'react/jsx-runtime';
import { Button } from 'primereact/button';
import { useState, useMemo } from 'react';

function IconOnlyHeaderTemplate(props, panelRef) {
  var _a;
  const [isCollapsed, setCollapsed] = useState((_a = props.collapsed) !== null && _a !== void 0 ? _a : false);
  const baseClass = 'panel-toggle-icon-only';
  const buttonClass = useMemo(() => isCollapsed ? baseClass : "active ".concat(baseClass), [isCollapsed]);
  if (!panelRef || !props.iconOnly) {
    return null;
  }
  return jsx(Button, {
    className: buttonClass,
    icon: props.header,
    onClick: () => {
      var _a;
      setCollapsed(!isCollapsed);
      (_a = panelRef.current) === null || _a === void 0 ? void 0 : _a.toggle(undefined);
    }
  });
}

export { IconOnlyHeaderTemplate };
